<template>
    <div>
        <van-tabs v-model="tabActive" :sticky="true" swipeable>
            <van-tab :title="tab.title" v-for="(tab, tabIndex) in tabTitle" :key="tabIndex">
                <van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" class="company_list-container">
                    <van-empty v-if="!companyList.length" description="没有公司认证" />
                        <div class="company_item-container"
                            v-for="(item, index) in companyList"
                            :key="'company_item' + index">
                            <van-cell clickable @click="toCompanyDetail(item.id)">
                                <van-cell class="company_item-card company_id" :title="item.info.company_name">
                                    <van-tag size="large" :color="getStatusColor(item.status)">{{$store.state.systemEnum.company.user_company_auth.status[item.status]}}</van-tag>
                                </van-cell>
                                <van-cell class="company_item-card" title="统一社会信用代码" :value="item.info.company_code"/>
                                <van-cell class="company_item-card" title="法定代表人" :value="item.info.legal_person"/>
                            </van-cell>
                            <van-cell  title="管理油卡" is-link v-if="item.status === '1'" @click="cardList(item.id)"/>
                        </div>
                </van-pull-refresh>
            </van-tab>
        </van-tabs>
        <van-button type="danger" square block style="position: fixed; left: 0; bottom: 0;" @click="toCompanyDetail()">开始认证</van-button>
    </div>
</template>

<script>
    import api from '../../assets/js/api'

    export default {
        name: 'companyList',
        data () {
            return {
                refreshLoading: false, //刷新中
                companyList: [],
                requestIsLock: false, // 请求锁
                tabActive: 1,
                tabTitle: [
                    {
                        title: '待审核',
                        status: 0,
                        color: '#999999',
                    }, {
                        title: '审核成功',
                        status: 1,
                        color: '#669944',
                    }, {
                        title: '审核失败',
                        status: 2,
                        color: '#aa4246',
                    }
                ]
            }
        },
        watch : {
            tabActive(newValue, oldValue){
                this.onRefresh();
            },
        },
        mounted() {
            this.onRefresh()
        },
        methods: {
            cardList(id) {
                this.$router.push({
                    name: 'CompanyCardList',
                    query: {user_company_auth_id: id}
                })
            },
            onRefresh () {
                if (this.requestIsLock) return
                this.finished = false
                this.refreshLoading = true;
                this.getCompanyList()
            },

            getStatusColor(status) {
                return this.tabTitle.filter(tabItem => tabItem.status == status)[0] ? this.tabTitle.filter(tabItem => tabItem.status == status)[0].color : '#666666'
            },

            getCompanyList () {
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                // 关锁
                this.requestIsLock = true
                api.request('/user_company_auth/list', {
                    status: this.tabTitle[this.tabActive].status,
                }).then(res => {
                    if (this.refreshLoading) {
                        this.companyList = res.data
                        this.refreshLoading = false
                    }
                }).finally(() => {
                    this.$toast.clear(loading);
                    // 开锁
                    this.requestIsLock = false
                })
            },

            // 跳转至公司详情
            toCompanyDetail (companyId) {
                let url =  companyId ? `/${this.$route.params.companyId}/company/company_detail/${companyId}` : `/${this.$route.params.companyId}/company/company_detail/null`
                this.$router.push({
                    path: url
                })
            }
        },
    }
</script>

<style lang="scss" scoped>
    .company_list-container {
        padding: 0 10px;
        .company_id {
            font-weight: bold;
            font-size: 16px;
            color: #999;

        }

        .van-pull-refresh {
            overflow: visible;
        }

        .company_item-container {
            margin-top: 10px;
            border-radius: 10px;
            background: #ffffff;
            box-shadow: 0 0 5px 0 rgba(0, 0, 0, .05);
            overflow: hidden;
        }

        .van-cell {
            padding: 10px 20px;
        }

        .company_item-card{
            padding: 0 0 10px;
            margin-bottom: 5px;
            .van-cell__value{
                overflow: visible;
                font-size: 16px;
            }
            &::after {
                left: 0;
                right: 0;
            }

            &:nth-last-child(1) {
                padding: 0;
                margin-bottom: 0;
            }
        }

        .company_item-checkout {
            display: flex;
            justify-content: flex-end;
            font-size: 14px;

            .company_item-total,
            .company_item-discounts {
                margin-right: 5px;
                color: #969799;
            }

            .company_item-actual_payment {
                color: #ee0a24;
                font-weight: bold;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/CompanyList.vue